<template>
  <div id='bd-aside'>
    <div>我的问卷</div>
    <div>创建问卷</div>
  </div>
</template>

<script>
export default {
  name: 'bd-aside'

}
</script>

<style scoped>

</style>
